import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { Row, Col, Button, Container, Collapse, Tooltip } from "reactstrap";
import { connect } from "react-redux";
import SizeList from "./SizeListV3";
import PriceTag from "./PriceTag";
import SneakerCondition from "./SneakerCondition";
import SizeChart from "./SizeChart";
import classnames from "classnames";
import PropTypes from "prop-types";
import { TextRupiah } from "../../../../../Text";
import SneakerInfoContainer from "../../../../../PageCheckout/Detail/SneakerInfoContainer";
import { ModalConditionGuide } from "../../../../../Modals";
import { formatCurrency } from "../../../../../../utils";

class Sizes extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
      _modalConditionGuide: false,
      slideDownToTop: "slide-bottom-top"
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.collapse !== this.props.collapse) {
      this.setState({
        slideDownToTop: null
      })
    }
  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  }

  toggleModalConditionGuide = () => {
    this.setState({
      _modalConditionGuide: !this.state._modalConditionGuide,
    });
  };

  _handleModalConditionGuide() {
    return (
      <ModalConditionGuide
        isOpen={this.state._modalConditionGuide}
        onToggle={this.toggleModalConditionGuide}
      />
    );
  }

  renderPrice() {
    const { selected } = this.props;

    if (selected !== null) {
      return (
        <div>
          <PriceTag
            showInstallments
            box_condition={selected.box_condition}
            asking_price={selected.asking_price}
            installments={this.props.installments}
          />
          <Row className="price">
            <Col className="price-col" sm={5} xs={5}>
              <h4>Highest Offer</h4>
            </Col>
            <Col className="price-col" sm={1} xs={1}>
              <h4>-</h4>
            </Col>
            <Col className="price-col" sm={6} xs={6}>
              <h4>
                <TextRupiah
                  color="red"
                  align="left"
                  value={
                    selected.highest_bid !== null
                      ? selected.highest_bid.amount
                      : 0
                  }
                  prefix="IDR. "
                />
              </h4>
            </Col>
          </Row>
        </div>
      );
    }
    return (
      <div className="price">
        <h4>Price</h4>
      </div>
    );
  }

  displayingSexSize() {
    const { availableSizes, usedSizes, preOrderSizes, variant } = this.props;

    return variant.sex === "M"
      ? "Mens"
      : variant.sex === "W" || variant.sex === "F"
        ? "Womens"
        : variant.sex;
  }

  render() {
    /* DECONSTRUCT PROPS */
    const {
      vintageList,
      ratio,
      currency,
      variant = {},
      collapse = "",
      availableSizes,
      selected = null,
      installments,
      preOrderSizes,
      isVintage,
      onSizeChanged,
      buttonBuyOffer,
      isVilla,
      usedSizes,
      handleCurrentPage,
      onToggle,
      isWomen,
      showPreverifiedInfoHandler,
      showHotProductInfoHandler,
    } = this.props;
    const { product = {}, SKU, slug, colour, id: variantId, variant_payment_methods = [] } = variant || {};

    const category = product ? product.category : {};
    const categoryName = category ? category.name : "";
    const isOnlyKickPoint = variant_payment_methods?.length === 1 && !!variant_payment_methods?.find((item) => item?.payment_method === "kick_point");

    /* CONDITIONS */
    const askingPrice =
      vintageList.length > 0
        ? vintageList.map(
          (item) =>
            parseFloat(item.asking_price) -
            parseFloat(item.subsidy_price || 0)
        )
        : [];
    const sortedPrices = askingPrice.sort((min, max) => min - max);

    return (
      <div className="size-container">
        {this._handleModalConditionGuide()}
        {categoryName === "handbags.old" || isVintage ? (
          <Col className="size-list" xs={12}>
            <div className={`${this.state.slideDownToTop ? this.state.slideDownToTop : "custom-collapse"}`}>
              <SizeList
                selected={selected}
                data={vintageList}
                handleSizeSelected={onSizeChanged}
                isCollapse={collapse}
                buttonBuyOffer={buttonBuyOffer}
                category={category}
                isVintage={isVintage}
                handleCurrentPage={handleCurrentPage}
                isWomen={isWomen}
                showPreverifiedInfoHandler={showPreverifiedInfoHandler}
                showHotProductInfoHandler={showHotProductInfoHandler}
                isOnlyKickPoint={isOnlyKickPoint}
              />
            </div>
          </Col>
        ) : (
          <Col className="size-list" xs={12}>
            {collapse === "NEW" && availableSizes.length > 0 && <div
              className={`${this.state.slideDownToTop ? this.state.slideDownToTop : "custom-collapse"}`}
            >
              <SizeList
                selected={selected}
                data={availableSizes}
                handleSizeSelected={onSizeChanged}
                isVilla={isVilla}
                isCollapse={collapse}
                buttonBuyOffer={buttonBuyOffer}
                category={category}
                handleCurrentPage={handleCurrentPage}
                isWomen={isWomen}
                showPreverifiedInfoHandler={showPreverifiedInfoHandler}
                showHotProductInfoHandler={showHotProductInfoHandler}
                isOnlyKickPoint={isOnlyKickPoint}
              />
            </div>}
            {collapse === "PO" && preOrderSizes.length > 0 && <div className={`${this.state.slideDownToTop ? this.state.slideDownToTop : "custom-collapse"}`}>
              <SizeList
                selected={selected}
                data={preOrderSizes}
                handleSizeSelected={onSizeChanged}
                isVilla={isVilla}
                isCollapse={collapse}
                buttonBuyOffer={buttonBuyOffer}
                category={category}
                handleCurrentPage={handleCurrentPage}
                isWomen={isWomen}
                showPreverifiedInfoHandler={showPreverifiedInfoHandler}
                showHotProductInfoHandler={showHotProductInfoHandler}
                isOnlyKickPoint={isOnlyKickPoint}
              />
            </div>}
            {collapse === "USED" && usedSizes.length > 0 && <div className={`${this.state.slideDownToTop ? this.state.slideDownToTop : "custom-collapse"}`} isOpen={collapse === "USED" ? true : false}>
              <SizeList
                selected={selected}
                data={usedSizes}
                handleSizeSelected={onSizeChanged}
                isVilla={isVilla}
                isCollapse={collapse}
                buttonBuyOffer={buttonBuyOffer}
                category={category}
                handleCurrentPage={handleCurrentPage}
                isWomen={isWomen}
                showPreverifiedInfoHandler={showPreverifiedInfoHandler}
                showHotProductInfoHandler={showHotProductInfoHandler}
                isOnlyKickPoint={isOnlyKickPoint}
              />
            </div>}
          </Col>
        )}
        <>
          {/* {categoryName === "handbags.old" || isVintage ? (
          <Col className="size-list" xs={12}>
            <SizeList
              selected={selected}
              data={vintageList}
              handleSizeSelected={onSizeChanged}
              isCollapse={collapse}
              buttonBuyOffer={buttonBuyOffer}
              category={category}
              isVintage={isVintage}
              handleCurrentPage={handleCurrentPage}
              isWomen={isWomen}
            />
          </Col>
        ) : (
          <Col className="size-list" xs={12}>
            <Collapse
              isOpen={
                collapse === "NEW" && availableSizes.length > 0 ? true : false
              }
            >
              <SizeList
                selected={selected}
                data={availableSizes}
                handleSizeSelected={onSizeChanged}
                isVilla={isVilla}
                isCollapse={collapse}
                buttonBuyOffer={buttonBuyOffer}
                category={category}
                handleCurrentPage={handleCurrentPage}
                isWomen={isWomen}
              />
            </Collapse>
            <Collapse isOpen={collapse === "PO" ? true : false}>
              <SizeList
                selected={selected}
                data={preOrderSizes}
                handleSizeSelected={onSizeChanged}
                isVilla={isVilla}
                isCollapse={collapse}
                buttonBuyOffer={buttonBuyOffer}
                category={category}
                handleCurrentPage={handleCurrentPage}
                isWomen={isWomen}
              />
            </Collapse>
            <Collapse isOpen={collapse === "USED" ? true : false}>
              <SizeList
                selected={selected}
                data={usedSizes}
                handleSizeSelected={onSizeChanged}
                isVilla={isVilla}
                isCollapse={collapse}
                buttonBuyOffer={buttonBuyOffer}
                category={category}
                handleCurrentPage={handleCurrentPage}
                isWomen={isWomen}
              />
            </Collapse>
          </Col>
        )} */}
        </>
      </div>
    );
  }
}
Sizes.propTypes = {
  selected: PropTypes.object,
  collapse: PropTypes.string,
  availableSizes: PropTypes.array,
  usedSizes: PropTypes.array,
  preOrderSizes: PropTypes.array,
  onToggle: PropTypes.func,
  onSizeChanged: PropTypes.func,
};

const mapStateToProps = (state) => ({
  ratio: state.dataAuth.userCurrency.ratio,
  currency: state.dataAuth.userCurrency.currency,
});

export default connect(mapStateToProps)(Sizes);
